import Products from "./Components/Products.vue";
import { SafetyCenterRouteGuard } from "./SafetyCenterRouteGuard";
import Safety from "./Views/Safety.vue";

export
{
    Products
};

export default {
    path: '/safety',
    name: 'Safety Center',
    meta: {
        allowAnonymous: false,
        title: 'Safety Center'
    },
    beforeEnter: SafetyCenterRouteGuard,
    component: Safety
};